<template>

  <div class="m-card-518-wrapper shadow-sm border p-2">
    <div class="text-center card-header-518 row mx-auto justify-content-around mt-3  ">
      <div class="card-image-518-wrapper col-3">
        <img class="img-fluid card-518-img  " :src="image" :alt="alt">
      </div>
      <slot>
        <div class="title-description-518 col-9 text-right">

          <div class="card-item-title row mx-auto justify-content-center">
            <h3 class="item-title-1 col-12">دندان پزشکی</h3>
            <h4 class="item-title-description col-12">بهترین مواد اولیه</h4>
          </div>
        </div>
        <div class="card-item-body">
          <p class="card-body-description-518">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam commodi corporis ea earum enim est eum
            facere fuga ipsum nemo nisi omnis, possimus praesentium quia quibusdam reprehenderit tempore temporibus.
            Aliquid architecto at aut consectetur, culpa dolore id illo ipsam laboriosam nisi non odit omnis praesentium
            quia quos, recusandae soluta tenetur!
          </p>
        </div>
        <div class="card-footer-518 pb-4 col-12 text-left">
          <div class="show-more-item-518 ">
              <span class="show-service-text">
                اطلاعات بیشتر
              </span>
            <a class="show-more-item-icon mx-2">
              <i class="bi bi-arrow-left"></i>
            </a>
          </div>
        </div>


      </slot>


    </div>

  </div>


</template>


<script>
import mA from "../Tags/A.vue";
import mImg from "../Tags/Img.vue";
import {CardProps} from "./CardProps";

export default {
  name: "Card518",
  components: {mA, mImg},
  props: {
    ...CardProps,
  }
}
</script>


<style scoped>
.m-card-518-wrapper {
  height: 300px;
  position: relative;
  border-radius: 1.5rem;


}

.card-518-img {
  width: 50px;
  height: 50px;

}

.item-title-1 {
  font-size: 1rem;
  font-weight: bold;

}

.item-title-description {
  font-size: 0.9rem;
  font-weight: lighter;
  line-height: 1.8rem;
  color: gray;


}

.card-item-body {

  margin: 14px 24px 66px 24px;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 24px;
  text-align: justify;
}

.show-more-item-icon {
  padding: 20px 20px 23px 23px;
  background: linear-gradient(214deg, #F6F8FB 12.49%, rgba(245, 248, 252, 0.00) 60.16%);
  border-radius: 50%;
  cursor: pointer;
}
</style>
